import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterSegmentList_template} from "../components/templates/newsletterSegmentList_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class newsletter_segments extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected segmentList: newsletterSegmentList_template;

    buildContent(): Array<Element> {
        this.segmentList = new newsletterSegmentList_template("newsletterSegmentList", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Segments");

        return [this.segmentList.build()];
    }

    protected getModuleName(): string {
        return "newsletter_segments";
    }

    fillPage(): void {
        this.filterList();
    }

    public segmentsListReorder(): void {
        this.filterList();
    }

    protected paginationOnPageClick(): void {
        this.filterList();
    }

    protected filterSimpleOnChange(): void {
        this.viewModel.newsletterSegmentList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.segmentList.builtTemplate.children.namedItem("list-results"));
        let url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/segments/get/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.segmentList.getViewModelForRequest())]);

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.segmentList.setSegments(responseParsed.data, obj.getBrandId());
                if (responseParsed.extraData && responseParsed.extraData.permissions) {
                    obj.segmentList.setPermissions(responseParsed.extraData.permissions);
                }
                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime) / 1000 * 100) / 100;
                obj.segmentList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);
                obj.viewModel.newsletterSegmentList.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.segmentList.builtTemplate.children.namedItem("list-results"));
        };
    }

    public view(id): void {
        page('/brand/' + this.getBrandId() + '/newsletter/segments/view/' + id + '/');
    }

    public add(): void {
        page('/brand/' + this.getBrandId() + '/newsletter/segments/add/');
    }

    public getBrandId(): string {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_segments.ts